// @ts-nocheck
import { WishListModel } from "@insite/client-framework/Types/ApiModels";

const getWishlistShowTags = (wishlist: WishListModel[] | undefined) => {
    return Boolean(wishlist?.find(x => x.wishListTags && x?.wishListTags.length >= 1));
};

export default getWishlistShowTags;
